import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LOGOUT, logoutUsers, RESET_STORE } from "../../redux/actions"; // Import logout action type
import { persistor } from "../../redux/store"; // Import persistor

const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const logoutUser = async () => {
      const result = await logoutUsers();
      if (result?.message === "Logged out") {
        dispatch({ type: LOGOUT }); // ✅ Clear Redux state
        dispatch({ type: "cart/setCount", payload: 0 });
        localStorage.removeItem("auth_token");

        // ✅ Clear localStorage
        localStorage.removeItem("user_data");
        localStorage.removeItem("cartIds");
        localStorage.removeItem("region");

        localStorage.removeItem("cartDatas");
        localStorage.removeItem("persist:root"); // Clears Redux Persist storage

        // ✅ Purge Redux Persist store
        persistor.flush().then(() => {
          dispatch({ type: RESET_STORE });
        });

        // ✅ Ensure async cleanup before navigation
        setTimeout(() => {
          dispatch({ type: RESET_STORE });
          navigate("/login");
        }, 100);
      } else {
        dispatch({ type: RESET_STORE });
        dispatch({ type: LOGOUT }); // ✅ Clear Redux state
        localStorage.removeItem("auth_token");
        localStorage.removeItem("user_data");
        localStorage.removeItem("cartIds");
        localStorage.removeItem("region");
        localStorage.removeItem("cartDatas");
        localStorage.removeItem("persist:root"); // Clears Redux Persist storage

        // ✅ Purge Redux Persist store
        // await persistor.purge();
        // ✅ Ensure async cleanup before navigation
        setTimeout(() => {
          dispatch({ type: RESET_STORE });
          navigate("/login");
        }, 500);
      }
    };

    logoutUser();
  }, [dispatch, navigate]);

  return <></>;
};

export default Logout;
